'use client';

import { Button } from '@heroui/react';

import '../button.css';
import { ButtonProps } from './interface';

export const HButton = ({
  mode = 'primary',
  size = 'medium',
  label,
  onPress = () => {},
  disabled,
  icon = null,
  iconPosition = 'end' as const,
  type = 'button',
  thin = false,
  fat = false,
  isLoading = false,
  withShadow = false,
}: ButtonProps) => {
  const buttonMode = disabled ? 'disabled' : mode;
  const iconClassName = `h-button--icon--${size} ${isLoading ? 'h-button--icon-loading' : ''}`;
  const shadowClass = withShadow ? 'h-button--shadow' : '';

  if (icon && iconPosition === 'end') {
    const Icon = icon;

    return (
      <Button
        className={`h-button h-button--${size} h-button--${buttonMode} font-text ${shadowClass}`}
        data-thin={thin}
        data-fat={fat}
        disabled={disabled}
        endContent={<Icon className={iconClassName} />}
        type={type}
        onPress={onPress}
      >
        {label}
      </Button>
    );
  }

  if (icon && iconPosition === 'start') {
    const Icon = icon;

    return (
      <Button
        className={`h-button h-button--${size} h-button--${buttonMode} font-text ${shadowClass}`}
        data-thin={thin}
        data-fat={fat}
        disabled={disabled}
        startContent={<Icon className={iconClassName} />}
        type={type}
        onPress={onPress}
      >
        {label}
      </Button>
    );
  }

  return (
    <Button
      className={`h-button h-button--${size} h-button--${buttonMode} font-text ${shadowClass}`}
      data-thin={thin}
      data-fat={fat}
      disabled={disabled}
      type={type}
      onPress={onPress}
    >
      {label}
    </Button>
  );
};
